import React, { useEffect, useState } from 'react';
import './RightSideNav.scss';
import { isIOS } from 'react-device-detect';
import ExchBetslip from '../../../components/ExchBetslip/ExchBetslip';
import OneClieckBet from '../../../components/ExchBetslip/OneClieckBet';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import ExchOpenBets from '../../../components/ExchOpenBets/ExchOpenBets';
import {
  Accordion,
  AccordionSummary,
  AccordionDetails,
} from '@material-ui/core';
import { RootState } from '../../../models/RootState';
import { connect } from 'react-redux';
import { UserBet } from '../../../models/UserBet';
import { PlaceBetRequest } from '../../../models/BsData';
import NewMarket from '../NewMarket/NewMarket';
import AddNewMarket from '../NewMarket/AddNewMarket';
import { NavLink, useLocation } from 'react-router-dom';
import CricketLiveStream from '../../../components/Livestream/CricketLiveStream';
import { fetchOpenBets } from '../../../store';

type StoreProps = {
  bets: PlaceBetRequest[];
  loggedIn: boolean;
  openBets: UserBet[];
  totalOrders: number;
  fetchOpenBets: (eventId: string) => void;
};

type RightSideNavProps = StoreProps & {
  backupStreamUrl: string;
  eventId: string;
  inplay: boolean;
  showliveStrem?: boolean;
  showStream: boolean;
};

const RightSideNav: React.FC<RightSideNavProps> = (props) => {
  const {
    bets,
    loggedIn,
    openBets,
    totalOrders,
    backupStreamUrl,
    eventId,
    inplay,
    showliveStrem,
    showStream,
    fetchOpenBets,
  } = props;
  const [openBetslip, setOpenBetslip] = useState<boolean>(true);
  const [showNewMarket, setShowNewMarket] = useState<boolean>(false);
  const location = useLocation();

  useEffect(() => {
    if (location?.pathname?.startsWith('/exchange_sports')) {
      let len = location.pathname.split('/').length;
      setShowNewMarket(
        len === 6 || location?.pathname !== '/exchange_sports/multi-markets'
      );
    }
  }, [location]);

  useEffect(() => {
    if (loggedIn) {
      let refreshInterval = setInterval(() => {
        if (openBets && openBets.length > 0) fetchOpenBets('');
      }, 10 * 1000);
      return () => {
        clearInterval(refreshInterval);
      };
    }
  }, [loggedIn]);

  return (
    <>
      <div className="right-side-nav">
        {/* <SearchBar /> */}
        <div
          className={isIOS ? 'betslip-section ios-betslip' : 'betslip-section'}
        >
          <Accordion
            className="right-side-accordion"
            expanded={openBetslip}
            onChange={(_, expanded) => setOpenBetslip(expanded)}
          >
            <AccordionSummary
              expandIcon={<ExpandMoreIcon className="expand-icon" />}
              aria-controls="panel1a-content"
              className="stream-header"
            >
              <div className="header-title"> Bet Slip ({bets.length})</div>
            </AccordionSummary>
            <AccordionDetails className="stream-body">
              <OneClieckBet />
              {bets.length > 0 ? <ExchBetslip mobileView={false} /> : null}
            </AccordionDetails>
          </Accordion>
        </div>

        {loggedIn ? (
          <Accordion className="right-side-accordion" defaultExpanded={true}>
            <AccordionSummary
              expandIcon={<ExpandMoreIcon className="expand-icon" />}
              aria-controls="panel1a-content"
              className="stream-header"
            >
              <div className="header-title">Open Bets ({totalOrders})</div>
            </AccordionSummary>
            <AccordionDetails className="stream-body">
              {totalOrders > 0 ? <ExchOpenBets /> : null}
            </AccordionDetails>
            {totalOrders > 25 ? (
              <NavLink to="/my_bets" className="navlink">
                View all
              </NavLink>
            ) : null}
          </Accordion>
        ) : null}

        {showNewMarket && loggedIn && inplay && showStream ? (
          <Accordion className="right-side-accordion" defaultExpanded={true}>
            <AccordionSummary
              expandIcon={<ExpandMoreIcon className="expand-icon" />}
              aria-controls="panel1a-content"
              className="stream-header"
            >
              <div className="header-title">Live Stream</div>
            </AccordionSummary>
            <AccordionDetails className="stream-body">
              {showliveStrem ? (
                <CricketLiveStream
                  eventID={eventId}
                  providerUrl={backupStreamUrl}
                />
              ) : null}
            </AccordionDetails>
          </Accordion>
        ) : null}
        {/* {!showNewMarket ? <NewMarket /> : <AddNewMarket isAccordion={true} />} */}
        <NewMarket />
      </div>
    </>
  );
};

const mapStateToProps = (state: RootState) => {
  const selectedEvent = state.exchangeSports.selectedEvent;
  return {
    loggedIn: state.auth.loggedIn,
    openBets: state.exchBetslip.openBets,
    totalOrders: state.exchBetslip.totalOrders,
    bets: state.exchBetslip.bets,
  };
};
const mapDispatchToProps = (dispatch: Function) => {
  return {
    fetchOpenBets: (eventId: string) => dispatch(fetchOpenBets(eventId)),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(RightSideNav);
